<template>
    <multi-input :compress="compress">
        <column :size="currentSelector.pSize || ''" v-for="currentSelector in selectors" :key="`selector-${currentSelector.modelField}`">
            <div class="sr-only">
              <label :for="currentSelector.modelField">{{currentSelector.label}}</label>
            </div>
            <a-select
                    v-model="document[currentSelector.modelField]"
                    :options="currentSelector.options"
                    class="full-sz"
                    :id="currentSelector.modelField"
                    :name="currentSelector.modelField"></a-select>
        </column>
    </multi-input>
</template>

<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    props: {
        document: {
          type: Object,
          required: true
        },
        selectors: {
          type: Array as () => Array<{}>,
          default: []
        },
        compress: {
          type: Boolean,
          default: false
        },
    },
  })
</script>
